<template>
<el-footer>
    <div class="bottom">
      <div class="copyright container">
        <!-- <div class="container">
          <span>当前在线人数：{{OnlineNumber}}</span>    
          <span>总访问量统计：{{Count}}</span> 
          <span>今日访问量：{{CurrentDay}}</span>  
        </div> -->
        <div class="" v-html="body"> </div>
      </div>

    </div>

  </el-footer>
</template>

<script>
import axios from "../../src/assets/config/axios.config";
    export default {
        name: "CommonFooter",
        data(){
          return{
            body:'',
            isycb:false,
            Count:0,
            CurrentDay:0,
            CurrentLast:0,
            OnlineNumber:0,
            
          }
        },
      async  mounted(){
          if(sessionStorage.getItem("SetItem")){
        let SetItem=JSON.parse(sessionStorage.getItem("SetItem"))
      SetItem.map(item=>{
        if(item.SetItemID==4530){
               item.Item_Value=="是"?this.isycb=true:this.isycb=false
          }
      })
    }
   

    this.getBody()
    this.getAllSum()
  },
    methods:{
        getBody(){
            let params=[80,8,9,1400]
        this.$store.dispatch("_getHeader",params).then(res=>{
          this.body=res.data.Data[0].Body
           sessionStorage.setItem("slqk",JSON.stringify(res.data.Data[2].Body))
      }).catch(err=>{
          console.log(err)
      })
    },
       getAllSum() {
      this.$store
        .dispatch("_getAllSum", { isen: false })
        .then((res) => {
          this.Count = res.data.Data.Count;
          this.CurrentDay = res.data.Data.CurrentDay;
          this.CurrentLast = res.data.Data.CurrentLast;
          this.OnlineNumber = res.data.Data.OnlineNumber;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goRss(){
       this.$store.dispatch('_GetRss').then(res=>{
              this.rssUrl=res.data.Message
              window.open(this.ImgUrl+this.rssUrl+'?')
         })
    },
    }
    }
</script>

<style scoped>
.container span{
  margin-right: 15px;
}
</style>
